/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import {
    PanelBody,
    RangeControl,
    SelectControl
} from '@wordpress/components';
import {
    useState,
    useEffect
} from '@wordpress/element';
/**
* Internal dependencies
*/
import {VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import {VayuBlocksRangeControl} from '@vayu-blocks';

const SlideItemSettingPanel = (props) => {

    const {
            attributes,
            setAttributes
        } = props;


        return(
        <>
        <PanelBody 
        title={ __( 'Setting', 'vayu-blocks' ) }
        className="th-panel" 
        initialOpen={ true }
         >

            <VayuBlocksRangeControl	
                                label={<VayuBlocksDeviceControl  label={ __( 'Slide Width', 'vayu-blocks' ) } classname='bold' />}
                                min={1}
                                max={100}
                                step={1}
                                marks={false}
                                withInputField={true}
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                attribute={{key:'slideWidth', value:attributes.slideWidth}}
                            />
               
                <VayuBlocksRangeControl	
                                label={<VayuBlocksDeviceControl  label={ __( 'Slide Gap', 'vayu-blocks' ) } classname='bold' />}
                                min={1}
                                max={100}
                                step={1}
                                marks={false}
                                withInputField={true}
                                onChange={(key, value) => setAttributes({ [key]: value })}
                                attribute={{key:'slideGap', value:attributes.slideGap}}
                            />
                
        </PanelBody>
        </>
    )

}
export default SlideItemSettingPanel;